module.exports = __webpack_public_path__ + "img/3x.a4d6a68.jpg";